import { Record, List } from 'immutable';

export const Product = new Record({
    id: '',
    name: '',
    image: ''
})

export const Variation = new Record({
    id: '',
    name: '',
    image: '',
    product: new Product(),
    fields: new List()
})

export const OrderLine = new Record({
    id: '',
    quantity: 0,
    variation: new Variation(),
    variationDetails: new List(),
    unitPrice: 0.0,
    status: ''
})


// WEBPACK FOOTER //
// ./src/redux/modules/model.js